module.exports = __webpack_public_path__ + "img/p1.2896548c.png";